import { render, staticRenderFns } from "./new.vue?vue&type=template&id=75ef8589&scoped=true&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"
import style0 from "./new.vue?vue&type=style&index=0&id=75ef8589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef8589",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ef8589')) {
      api.createRecord('75ef8589', component.options)
    } else {
      api.reload('75ef8589', component.options)
    }
    module.hot.accept("./new.vue?vue&type=template&id=75ef8589&scoped=true&", function () {
      api.rerender('75ef8589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/new.vue"
export default component.exports